



// 定位图标——主流程
const MainRoutes = Array.from({ length: 7 }, (_, i) => ({
  path: `icon/position/index${i + 1}`,
  name: `icon/positionIndex${i + 1}`,
  component: () => import(`@/views/recognize/icon/position/index${i + 1}.vue`)
}))



export default {
  path: '/recognize',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [

    // 定位图标——主流程，开始
    ...MainRoutes,
  ],
};
